export const SESSION_WARNING_TIMER = 10 * 60 * 1000;
// The number of ms of inactivity before warning the user

export const SESSION_TIMEOUT_TIMER = 5 * 60 * 1000;
// The number of ms AFTER the warning before logging the user out

export const SESSION_REFRESH_INTERVAL = 14 * 60 * 1000;
// The number of ms between periodic calls to refresh VIS Gateway and Legacy sessions
